// Insurely identifies companies by code ("se-folksam") and sends no display name, so we keep
// our own labels. Mirrors INSURELY_COMPANIES in fund-management-service, plus se-seb-bank,
// which that map omits because the backend re-maps it onto se-seb.
const LABELS: Record<string, string> = {
  "se-lansforsakringar": "Länsförsäkringar",
  "se-seb": "SEB",
  "se-seb-bank": "SEB",
  "se-handelsbanken": "Handelsbanken",
  "se-folksam": "Folksam",
  "se-kpa": "KPA Pension",
  "se-alecta": "Alecta",
  "se-swedbank": "Swedbank",
  "se-nordnet": "Nordnet",
  "se-kapan": "Kåpan Pensioner",
  "se-movestic": "Movestic",
  "se-nordea": "Nordea",
  "se-spp": "SPP",
  "se-avanza": "Avanza",
  "se-spv": "SPV",
  "se-skandia": "Skandia",
  "se-amf": "AMF",
  "se-futur": "Futur Pension",
  "se-pp-pension": "PP Pension",
  "se-lysa": "Lysa",
  "se-svenska-fribrevsbolaget": "Svenska Fribrevsbolaget",
};

// Unknown codes still have to render: drop the market prefix and title-case the rest.
export const companyLabel = (code: string): string =>
  LABELS[code] ??
  code
    .replace(/^[a-z]{2}-/, "")
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
